import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { FileUploadModalBaseComponent } from '../../../../shared/components/file-upload-modal/file-upload-modal-base.component';

import { NotificationService, UncontrolledEntitiesService } from '../../../../shared/services';
import { ModalService } from '../../../../shared/modules/modal';

import { TranslationConstants } from '../../../../shared/constants';

@Component({
  selector: 'uncontrolled-entity-import-modal',
  templateUrl: './uncontrolled-entity-import-modal.component.html',
})
export class UncontrolledEntityImportModalComponent extends FileUploadModalBaseComponent {

  constructor(
    private _entitiesService: UncontrolledEntitiesService,
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    protected translate: TranslateService
  ) {
    super(notificationService, modalService, translate);
  }

  upload(): void {
    if (this.fileTypeInvalid) {
      return;
    }

    this.resetErrors();
    if (this.showLoader || !this.fileToUpload) {
      return;
    }

    this.showLoader = true;
    this._entitiesService.uploadUncontrolledEntitiesFile(this.fileToUpload).subscribe(({ data }) => {

      this.columns = data.headers.map((header) => {
        return { header };
      });

      this.allowedFields = data.allowed;
      this.filteredAllowedFields = data.allowed;
      this.fileHash = data.hash;
      this.showLoader = false;
      this.uploaded = true;
      this.handleDefaultFieldsForHeaders();
    });
  }

  startImport(): void {
    this.responseErrors = [];

    if (this.showLoader) {
      return;
    }

    const payload = this.prepareImportPayload();
    if (payload.mappings.length === 0) {
      this.responseErrors.push(TranslationConstants.ERROR_IMPORT_NO_MAPPING);
      return;
    }

    this.showLoader = true;
    this._entitiesService.submitUncontrolledEntitiesMappings(payload).subscribe(() => {
      this.showLoader = false;
      this.closeAllModals();
      this.success();
    });
  }
  
  showLabel(column) {
    const allowedField = this.filteredAllowedFields.find((allowed) => allowed.field === column.field);
    return allowedField.label;
  }
}
